import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { MainPageStyles } from "./MainPageStyles";
import { Header } from "../../components/Header/Header";
import { SideMenu } from "../../components/SideMenu/SideMenu";
import { Main } from "../../components/Main/Main";
import { useParams } from "react-router-dom";
import { EnumPages } from "../../commons/EnumPages";
import { UserServices } from "../../components/UserServices/UserServices";
import { EnterpriseServices } from "../../components/EnterpriseServices/EnterpriseServices";
import { EnterprisePrivacy } from "../../components/EnterprisePrivacy/EnterprisePrivacy";
import { UserVerifications } from "../../components/UserVerifications/UserVerifications";
import { UserPrivacy } from "../../components/UserPrivacy/UserPrivacy";
import { UserCancelAccount } from "../../components/UserCancelAccount/UserCancelAccount";
import { EnterpriseVerifications } from "../../components/EnterpriseVerifications/EnterpriseVerifications";
import { EnterpriseDelete } from "../../components/EnterpriseDelete/EnterpriseDelete";
import { EnterpriseTeam } from "../../components/EnterpriseTeam/EnterpriseTeam";
import { Alerts } from "../../components/Alerts/Alerts";
import {
  getReplaceMode,
} from "../../services/Commons";
import { RequiredData } from "../../components/RequiredData/RequiredData";
import { CommonStyles } from "../../commons/CommonStyles";
import { checkIsNullUndefined, finishGlobalOperation } from "../../commons/Utils";
import { SystemUser } from "../../components/SystemUser/SystemUser";
import { MainBackGroundPage } from "../../components/Templates/MainBackGroundPage";
import { UnifyAccounts } from "../../components/UnifyAccounts/UnifyAccounts";

export function MainPage() {
  const commonClasses = CommonStyles();
  const classes = MainPageStyles();
  const { idPage, idEnterprise } = useParams();
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [refreshEnterprises, setRefreshEnterprises] = useState({ flag: false, enterprise: null });
  const [updateUser, setUpdateUser] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    color: "",
    message: "",
  });
  const [resetPage, setResetPage] = useState(false);
  const [resetAlert, setResetAlert] = useState(false);
  const [isSpecialUser, setIsSpecialUser] = useState(false);
  const [enterpriseList, setEnterpriseList] = useState([]);

  useEffect(() => {
    setResetAlert(!resetAlert);
  }, [idPage, resetPage]);

  const finishOperation = (color, message, auxOpen) => {
    finishGlobalOperation(setAlert, color, message, auxOpen);
  };

  const handleShowSideMenu = () => {
    const flag = showSideMenu;
    setShowSideMenu(!flag);
  };

  const getIsOrganization = () => {
    let auxEnterprise = enterpriseList.find(ent => ent.oid == idEnterprise);
    return auxEnterprise?.isOrganization;
  };

  const getIsTitular = () => {
    let auxEnterprise = enterpriseList.find(ent => ent.oid == idEnterprise);
    return auxEnterprise?.isTitular;
  };

  const setUpdateEnterprises = (value) => {
    let auxRefresh = JSON.parse(JSON.stringify(refreshEnterprises));
    auxRefresh.flag = !auxRefresh.flag;
    auxRefresh.enterprise = value;
    setRefreshEnterprises(auxRefresh);
  };

  const renderPage = () => {

    switch (idPage) {
      case EnumPages.UserServices:
        return <UserServices />;
      case EnumPages.EnterpriseServices:
        return (
          <EnterpriseServices
            idEnterprise={idEnterprise}
            setUpdateEnterprises={setUpdateEnterprises}
            getIsOrganization={getIsOrganization}
            getIsTitular={getIsTitular}
          ></EnterpriseServices>
        );
      case EnumPages.EnterprisePrivacy:
        return (
          <EnterprisePrivacy
            idEnterprise={idEnterprise}
          ></EnterprisePrivacy>
        );
      case EnumPages.EnterpriseDelete:
        return (
          <EnterpriseDelete
            idEnterprise={idEnterprise}
            setUpdateEnterprises={setUpdateEnterprises}
          ></EnterpriseDelete>
        );
      case EnumPages.UserVerifications:
        return (
          <UserVerifications />
        );
      case EnumPages.UserData:
        return (
          <RequiredData
            isRegistry={false}
            setUpdateUser={setUpdateUser}
            forUser={true}
            forEnterprise={false}
            onlyMandatories={false}
            mainPage={true}
            resetAlert={resetAlert}
            forceResetPage={resetPage}
            finishOperation={finishOperation}
          />
        );
      case EnumPages.UserPrivacy:
        return <UserPrivacy />;
      case EnumPages.UserCancelAccount:
        return (
          <UserCancelAccount
            enterpriseList={enterpriseList}
          />
        );
      case EnumPages.EnterpriseData:
        return (
          <RequiredData
            isRegistry={false}
            setUpdateEnterprises={setUpdateEnterprises}
            idEnterprise={idEnterprise}
            forUser={false}
            forEnterprise={true}
            onlyMandatories={false}
            mainPage={true}
            resetAlert={resetAlert}
            forceResetPage={resetPage}
            finishOperation={finishOperation}
            enterpriseList={enterpriseList}
            getIsOrganization={getIsOrganization}
            getIsTitular={getIsTitular}
          />
        );
      case EnumPages.EnterpriseCreate:
        return (
          <RequiredData
            isRegistry={false}
            setUpdateEnterprises={setUpdateEnterprises}
            forUser={false}
            forEnterprise={true}
            onlyMandatories={false}
            mainPage={true}
            resetAlert={resetAlert}
            isCreate={true}
            forceResetPage={resetPage}
            finishOperation={finishOperation}
            enterpriseList={enterpriseList}
          />
        );
      case EnumPages.EnterpriseTeam:
        return (
          <EnterpriseTeam
            idEnterprise={idEnterprise}
            getIsTitular={getIsTitular}
          ></EnterpriseTeam>
        );
      case EnumPages.EnterpriseVerifications:
        return (
          <EnterpriseVerifications
            idEnterprise={idEnterprise}
            setUpdateEnterprises={setUpdateEnterprises}
            getIsOrganization={getIsOrganization}
            getIsTitular={getIsTitular}
          ></EnterpriseVerifications>
        );
      case EnumPages.AuxUserData:
        return (
          <RequiredData
            isRegistry={false}
            setUpdateUser={setUpdateUser}
            forUser={true}
            forEnterprise={false}
            onlyMandatories={false}
            mainPage={true}
            resetAlert={resetAlert}
            auxiliarTab={true}
            forceResetPage={resetPage}
            finishOperation={finishOperation}
          />
        );
      case EnumPages.SystemUser:
        return (
          <SystemUser
            idEnterprise={idEnterprise}
            getIsOrganization={getIsOrganization}
            getIsTitular={getIsTitular}
          />
        );
      case EnumPages.AuxEnterpriseData:
        return (
          <RequiredData
            isRegistry={false}
            setUpdateEnterprises={setUpdateEnterprises}
            idEnterprise={idEnterprise}
            forUser={false}
            forEnterprise={true}
            onlyMandatories={false}
            mainPage={true}
            resetAlert={resetAlert}
            auxiliarTab={true}
            forceResetPage={resetPage}
            finishOperation={finishOperation}
            getIsTitular={getIsTitular}
            enterpriseList={enterpriseList}
            getIsOrganization={getIsOrganization}
          />
        );
      case EnumPages.UnifyAccounts:
        return (
          <UnifyAccounts finishOperation={finishOperation} />
        );
      default:
        return <Main isSpecialUser={isSpecialUser}></Main>;
    }
  };

  return (
    <Grid className={classes.mainDiv}>
      <Alerts alert={alert} setAlert={setAlert}></Alerts>
      <Header setShowSideMenu={handleShowSideMenu} />
      {getReplaceMode() != "true" ?
        <SideMenu
          showSideMenu={showSideMenu}
          setShowSideMenu={handleShowSideMenu}
          refreshEnterprises={refreshEnterprises}
          updateUser={updateUser}
          setUpdateUser={setUpdateUser}
          resetPage={resetPage}
          setResetPage={setResetPage}
          setIsSpecialUser={setIsSpecialUser}
          isSpecialUser={isSpecialUser}
          enterpriseList={enterpriseList}
          setEnterpriseList={setEnterpriseList}
        /> : null}
      <Grid className={
        !showSideMenu ? commonClasses.container : commonClasses.hideContainer
      }>
        {checkIsNullUndefined(idPage) ? renderPage() :
          <MainBackGroundPage page={idPage} enterpriseList={enterpriseList} idEnterprise={idEnterprise}>
            {renderPage()}
          </MainBackGroundPage>
        }
      </Grid>
    </Grid>
  );
}
